module.exports = __webpack_public_path__ + "img/school_esyc2.9c2f1693.png";